import request from 'superagent'
import {controltables} from "conf"
import R from "ramda"


export default (locale, cb) => {
  const url = controltables({lang:'fr'})
  request
    .get(url)
    .end((err, res) => err ? cb(err) : cb(null, res.body))
}




/** WEBPACK FOOTER **
 ** ./app/api/controltables.js
 **/